<template>
	<div class="information qualityenterprise">
		<leftnav class="fl" :mkcode="(curWebsite.type == 5 || curWebsite.type == 6) ? 'T' : 'B'"
			:itemcode="(curWebsite.type == 5 || curWebsite.type == 6) ? 'T-HYTZDT' : 'B-DTJC'"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title" v-if="curWebsite.type != 5 && curWebsite.type != 6">动态监测</span>
						<span class="fl right_title" v-if="curWebsite.type == 5 || curWebsite.type == 6">{{ curWebsite.type
							== 5 ? '投资' : "产业" }}动态</span>
					</div>
					<div class="opport-screen-list1">
						<dynamicNav tabCode="cyzx" v-if="curWebsite.type != 5 && curWebsite.type != 6"></dynamicNav>
						<!-- 投资版名字 行业动态监测 -->
						<dynamicNavTZ code="hydttz" v-if="curWebsite.type == 5 || curWebsite.type == 6"></dynamicNavTZ>
						<!-- <dl class="opport-screen bdbe">
							<dt class="fl">产业分类</dt>
							<dd class="fl ">
								<span :key="index" v-for="(item,index) in meunlist"
									:class="notioncode==item.notioncode?' a-screen current' :'a-screen'"
									@click="menutoggle(item)">{{item.notion}}</span>
							</dd>
						</dl> -->
						<dl class="opport-screen bdbe">
							<dt class="fl">热点产业</dt>
							<dd class="fl">
								<span @click="industrychoose(1, { id: 0, children: [] });"
									:class="industrycode1 == 0 ? 'a-screen current' : 'a-screen'">全部</span>
								<span :key="index" v-for="(item, index) in hotindustry" @click="industrychoose(1, item);"
									:class="industrycode1 == item.id ? 'a-screen current' : 'a-screen'">{{ item.name }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="hotindustrychild.length > 0">
							<dt class="fl titleop">细分产业</dt>
							<dd class="fl">
								<span @click="industrycode2 = 0; getdynamiclist()"
									:class="industrycode2 == 0 ? 'a-screen current' : 'a-screen'">全部</span>
								<span :key="index" v-for="(item, index) in hotindustrychild" @click="industrychoose(2, item);"
									:class="industrycode2 == item.id ? 'a-screen current' : 'a-screen'">{{ item.name }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="categoryList.length > 0">
							<dt class="fl">关键词 </dt>
							<dd class="fl ">
								<span :class="categoryId == 0 ? ' a-screen current' : 'a-screen'"
									@click="keyClick(0)">全部</span>
								<span :key="index" v-for="(item, index) in categoryList"
									:class="categoryId == item.id ? ' a-screen current' : 'a-screen'"
									@click="keyClick(item.id)">{{ item.name }}</span>
							</dd>
						</dl>
					</div>
				</div>
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
						<!-- <p class="fl"   v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】条相关招商情报动态</p> -->
					</div>
					<div class="information_content information_box">
						<div class="infornews" :key="i" v-for="(list, i) in listdata">
							<div @click="routerlinkid('/news', list.id, 5)" class="infornews_d">
								<h5 class="title"><span class="fl info_title">{{ list.title }}</span><span
										class="fr">{{ list.publishTime }}</span></h5>
								<p class="onlyLine-text">{{ list.summary }}</p>
							</div>
							<div class="basefont-nocur fz15 ">
								<span>{{ list.categoryText }}</span>
							</div>
						</div>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'timefor',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {},
			searchtype: 5, //行业投资动态
			curWebsite: this.$api.getWebsiteType(),
			title: "行业投资动态",
			listdata: [],
			page: 1, //显示的是哪一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数
			hotindustry: [],
			hotindustrychild: [],
			industrycode1: "",
			industrycode2: '',
			industryid: 0,
			categoryList: [],
			categoryId: 0,
			isShowFreeUserTips: false
		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.userdata = this.getuseriformation();
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		// this.bus.$emit('loading', true);
		if (this.userdata.edition < 1) {
			var _this = this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				_this.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.getCategoryList();
		this.gethotindustry();
		this.getdynamiclist();
	},

	methods: {

		keyClick(id){
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			this.categoryId = id; 
			this.getdynamiclist();
		},
		//获取分类列表
		getCategoryList() {
			var _this = this;
			this.$axios.get(this.$api.park.news.category(), {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					console.log('获取分类列表', res.data);
					_this.categoryList = res.data.list;
					// _this.notionlist1=_this.notionlist[0].children;
				} else {
					_this.tokenfailed(res.data.msg);
				}
			});
		},

		//概念单选 层级显示
		//获取行业列表
		gethotindustry() {
			var _this = this;
			this.$axios.get(this.$api.park.news.industry(), {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					console.log('获取行业列表', res.data);
					_this.hotindustry = res.data.list;
					// _this.notionlist1=_this.notionlist[0].children;
				} else {
					_this.tokenfailed(res.data.msg);
				}
			});
		},
		industrychoose(step, list) {
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			if (list.id == this.industryid) { return; }
			if (step == 1) {
				this.hotindustrychild = list.children;
				this.industrycode2 = '';
				this.industrycode1 = list.id;
			} else if (step == 2) {
				this.industrycode2 = list.id;
			};
			this.industryid = list.id;
			// console.log(list.id,this.industryid)
			this.getdynamiclist();
		},
		getdynamiclist(page) {
			this.bus.$emit('loading', true);
			this.page = page ? page : 1;
			var _this = this;
			var industryja1 = this.splicing('industry', this.industrycode1);
			var industryja2 = this.splicing('industry2', this.industrycode2);
			var categoryJa = this.splicing('category', this.categoryId);
			var ajaxurl = this.$api.park.news.list() + '?page=' + this.page + industryja1 + industryja2 + categoryJa;
			// console.log(ajaxurl);
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log(res.data);
				if (res.data.success) {
					_this.listdata = res.data.list;
					_this.bus.$emit('loading', false);
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
				} else {

				}
			}).catch(function (error) {
				_this.bus.$emit('loading', false);
				// 请求失败处理 console.log(error);
			});
		},
		pageHandler: function (page) {
			// this.page = page;
			this.getdynamiclist(page);
		},


	},
}
</script>

<style></style>